<template>
</template>

<script>
  export default {
    name: "ShowError",
    props: ['typeMessage', 'text'],
    created() {
      toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "8000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
        "onHidden": this.cerrar
      }
      toastr[this.typeMessage](this.text)
    },
    methods:{
      cerrar(){
        this.$emit('closeError')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/ShowError.vue